module.exports = __webpack_public_path__ + "media/static/flags/nl-a10fa53e0adee0aca2b16af970ff8baa.svg";